<div class="card-image py-1">
  <div class="container">
    <div class="text-left px-4 offset-1 col-10">
      <div>
        <h1 class="card-title h1-responsive pt-2 mb-3 font-bold" style="color: rgb(118,168,255)">{{ title }}</h1>
        <hr style="border: 1px solid grey;">
        <p class="mb-5" style="color: grey">{{ comment }}</p>
      </div>
    </div>
  </div>
</div>
